<template>
  <div v-if="agree !== null && agree !== 1">
    <div v-if="loading" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
    <h3 v-show="agree === 2" id="clientFormHeader2" class="ang-heading mt-5">
      Doprecyzuj zakres ochrony, który potrzebujesz
    </h3>
    <div class="ang-card mt-5">
      <form
        role="form"
        id="client-apk-form"
        class="ang-card-body"
        :action="action"
        method="POST"
        novalidate="novalidate"
      >
        <input type="hidden" name="notify" :value="prevent ? 0 : 1" />
        <div v-if="agree === 2">
          <div
            id="car"
            v-if="insurances.includes('car') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">Pojazd</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/samochod.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <span class="insurance-list__col-right-title"
                >Określ przedmiot ochrony:</span
              >
              <div class="form-check">
                <div
                  class="form-group d-flex"
                  v-for="(i, k) in items.samochodItems"
                  :key="k"
                >
                  <div
                    class="custom-checkbox custom-checkbox--small custom-checkbox--red"
                  >
                    <input
                      type="checkbox"
                      :id="i"
                      :value="i"
                      :name="'data[apk][Samochod][]'"
                      required
                    />
                    <label :for="i">
                      <svg class="checkbox" viewbox="0 0 40 40">
                        <rect x="2" y="2" width="16" height="16"></rect>
                        <polyline points="5,8 8,14 15,5"></polyline>
                      </svg>
                    </label>
                  </div>
                  <label :for="i" class="ang-form-label">{{ i }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            id="travel"
            v-if="insurances.includes('travel') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">Podróże</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/podroze.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <div class="row">
                <div class="col-md-4">
                  <span class="insurance-list__col-right-title"
                    >Określ kierunek:</span
                  >
                  <div class="form-check">
                    <div
                      v-on:click="checkCountry"
                      class="form-group d-flex"
                      v-for="(i, k) in items.turystykaItems.direction"
                      :key="k"
                      @click="hiddenTravelOptions = true"
                    >
                      <div
                        class="custom-checkbox custom-checkbox--small custom-checkbox--red"
                      >
                        <input
                          type="radio"
                          :id="i"
                          :value="i"
                          name="data[apk][Turystyka][Kierunek][]"
                          required
                        />
                        <label :for="i">
                          <svg class="checkbox" viewbox="0 0 40 40">
                            <rect x="2" y="2" width="16" height="16"></rect>
                            <polyline points="5,8 8,14 15,5"></polyline>
                          </svg>
                        </label>
                      </div>
                      <label :for="i" class="ang-form-label">{{ i }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div v-show="hiddenTravelOptions !== null" class="form-check">
                    <span class="insurance-list__col-right-title"
                      >Określ cel wyjazdu:</span
                    >
                    <div
                      class="form-group d-flex"
                      v-for="(i, k) in items.turystykaItems.subject"
                      :key="k"
                    >
                      <div
                        class="custom-checkbox custom-checkbox--small custom-checkbox--yellow"
                      >
                        <input
                          type="checkbox"
                          :id="i+k"
                          :value="i"
                          name="data[apk][Turystyka][Cel][]"
                          required
                        />
                        <label :for="i+k">
                          <svg class="checkbox" viewbox="0 0 40 40">
                            <rect x="2" y="2" width="16" height="16"></rect>
                            <polyline points="5,8 8,14 15,5"></polyline>
                          </svg>
                        </label>
                      </div>
                      <label :for="i+k" class="ang-form-label">{{ i }}</label>
                    </div>
                  </div>
                </div>
                <div v-show="hiddenTravelOptions !== null" class="col-md-4">
                  <div class="form-check">
                    <span class="insurance-list__col-right-title"
                      >Określ zakres ochrony:</span
                    >
                    <div
                      class="form-group d-flex"
                      v-for="(i, k) in items.turystykaItems.range"
                      :key="k"
                    >
                      <div
                        class="custom-checkbox custom-checkbox--small custom-checkbox--blue"
                      >
                        <input
                          type="checkbox"
                          :id="i"
                          :value="i"
                          name="data[apk][Turystyka][Zakres][]"
                          required
                        />
                        <label :for="i">
                          <svg class="checkbox" viewbox="0 0 40 40">
                            <rect x="2" y="2" width="16" height="16"></rect>
                            <polyline points="5,8 8,14 15,5"></polyline>
                          </svg>
                        </label>
                      </div>
                      <label :for="i" class="ang-form-label">{{ i }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="property"
            v-if="insurances.includes('property') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">Nieruchomości</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/dom.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <div class="row">
                <div class="col-md-4">
                  <span class="insurance-list__col-right-title"
                    >Określ przedmiot ochrony:</span
                  >
                  <div class="form-check">
                    <div
                      :class="'property-range' + k"
                      class="form-group d-flex"
                      v-for="(i, k) in items.domItems.subject"
                      :key="k"
                    >
                      <div
                        v-on:click="checkInsurances"
                        class="custom-checkbox custom-checkbox--small custom-checkbox--red"
                      >
                        <input
                          type="checkbox"
                          :id="i"
                          :value="i"
                          :name="'data[apk][Dom][]'"
                          required
                        />
                        <label :for="i">
                          <svg class="checkbox" viewbox="0 0 40 40">
                            <rect x="2" y="2" width="16" height="16"></rect>
                            <polyline points="5,8 8,14 15,5"></polyline>
                          </svg>
                        </label>
                      </div>
                      <label :for="i" class="ang-form-label">{{ i }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="hiddenPropertyOptions === false" class="col-md-4">
                  <span class="insurance-list__col-right-title"
                    >Określ zakres ochrony:</span
                  >
                  <div class="form-check">
                    <div
                      :class="'property-range' + k"
                      class="form-group d-flex"
                      v-for="(i, k) in items.domItems.range"
                      :key="k"
                    >
						<div
							class="custom-checkbox custom-checkbox--small custom-checkbox--yellow"
						>
							<input
							type="checkbox"
							:id="i.value"
							:value="i.value"
							:name="'data[apk][Dom][Zakres][]'"
							required
							/>
							<label :for="i.value">
							<svg class="checkbox" viewbox="0 0 40 40">
								<rect x="2" y="2" width="16" height="16"></rect>
								<polyline points="5,8 8,14 15,5"></polyline>
							</svg>
							</label>
						</div>
						<label :for="i.value" class="ang-form-label">{{ i.label }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="hiddenPropertyOptions === false" class="col-md-4">
                  <span class="insurance-list__col-right-title"
                    >Określ przeznaczenie ubezpieczanej nieruchomości:</span
                  >
                  <div class="form-check">
                    <div
                      class="form-group d-flex"
                      v-for="(i, k) in items.domItems.destiny"
                      :key="k"
                    >
                      <div
                        class="custom-checkbox custom-checkbox--small custom-checkbox--blue"
                      >
                        <input
                          type="checkbox"
                          :id="i"
                          :value="i"
                          :name="'data[apk][Dom][Przeznaczenie][]'"
                          required
                        />
                        <label :for="i">
                          <svg class="checkbox" viewbox="0 0 40 40">
                            <rect x="2" y="2" width="16" height="16"></rect>
                            <polyline points="5,8 8,14 15,5"></polyline>
                          </svg>
                        </label>
                      </div>
                      <label :for="i" class="ang-form-label">{{ i }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="agricultural"
            v-if="insurances.includes('agricultural') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">Rolne</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/rolnikszukaubezpieczenia.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <span class="insurance-list__col-right-title"
                >Określ przedmiot ochrony:</span
              >
              <div class="form-check">
                <div
                  class="form-group d-flex"
                  v-for="(i, k) in items.rolneItems"
                  :key="k"
                >
                  <div
                    class="custom-checkbox custom-checkbox--small custom-checkbox--red"
                  >
                    <input
                      type="checkbox"
                      :id="i"
                      :value="i"
                      :name="'data[apk][Rolne][]'"
                      required
                    />
                    <label :for="i">
                      <svg class="checkbox" viewbox="0 0 40 40">
                        <rect x="2" y="2" width="16" height="16"></rect>
                        <polyline points="5,8 8,14 15,5"></polyline>
                      </svg>
                    </label>
                  </div>
                  <label :for="i" class="ang-form-label">{{ i }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            id="life"
            v-if="insurances.includes('life') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">Życie</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/tarczaserce.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <span class="insurance-list__col-right-title"
                >Określ przedmiot ochrony:</span
              >
              <div class="form-check">
                <div
                  :class="'life-item' + k"
                  class="form-group d-flex"
                  v-for="(i, k) in items.zycieItems"
                  :key="k"
                >
                  <div
                    class="custom-checkbox custom-checkbox--small custom-checkbox--red"
                  >
                    <input
                      type="checkbox"
                      :id="i"
                      :value="i"
                      :name="'data[apk][Zdrowotne][]'"
                      required
                    />
                    <label :for="i">
                      <svg class="checkbox" viewbox="0 0 40 40">
                        <rect x="2" y="2" width="16" height="16"></rect>
                        <polyline points="5,8 8,14 15,5"></polyline>
                      </svg>
                    </label>
                  </div>
                  <label :for="i" class="ang-form-label">{{ i }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            id="oc"
            v-if="insurances.includes('oc') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">OC zawodowe</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/biz.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <div class="col-md-4 p-0 mb-3">
                <span class="insurance-list__col-right-title"
                  >Określ przedmiot ochrony:</span
                >
                <select-field
                  :name="'data[apk][OC Zawodowe][]'"
                  css="width: 100%"
                  placeholder="Wybierz"
                  :options="items.ocItems"
                  @changed="checkOc"
                  required
                ></select-field>
              </div>
              <div
                v-if="selectedOc === true"
                class="insurance-list__col-textarea"
              >
                <span class="insurance-list__col-right-title">Inne:</span>
                <textarea
                  class="ang-form-control insurance-list__col-right-area"
                  name="data[apk][OC Inne][]"
                  rows="3"
                />
              </div>
            </div>
          </div>
          <div
            id="medicine"
            v-if="insurances.includes('medicine') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">Pakiety medyczne</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/zdrowotne.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <span class="insurance-list__col-right-title"
                >Określ przedmiot ochrony:</span
              >
              <div class="form-check">
                <div
                  class="form-group d-flex"
                  v-for="(i, k) in items.zdrowotneItems"
                  :key="k"
                >
                  <div
                    class="custom-checkbox custom-checkbox--small custom-checkbox--red"
                  >
                    <input
                      type="checkbox"
                      :id="i"
                      :value="i"
                      :name="'data[apk][pakiety Medyczne][]'"
                      required
                    />
                    <label :for="i">
                      <svg class="checkbox" viewbox="0 0 40 40">
                        <rect x="2" y="2" width="16" height="16"></rect>
                        <polyline points="5,8 8,14 15,5"></polyline>
                      </svg>
                    </label>
                  </div>
                  <label :for="i" class="ang-form-label">{{ i }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            id="company"
            v-if="insurances.includes('company') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">Firma</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/firma.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <span class="insurance-list__col-right-title"
                >Określ przedmiot ochrony:</span
              >
              <div class="form-check">
                <div v-for="(i, k) in items.firmaItems" :key="k">
                  <div class="form-group d-flex">
                    <div
                      class="custom-checkbox custom-checkbox--small custom-checkbox--red"
                    >
                      <input
                        v-model="i.checked"
                        type="checkbox"
                        :id="i.title"
                        :value="i.title"
                        :name="'data[apk][Firma][]'"
                        required
                      />
                      <label :for="i.title">
                        <svg class="checkbox" viewbox="0 0 40 40">
                          <rect x="2" y="2" width="16" height="16"></rect>
                          <polyline points="5,8 8,14 15,5"></polyline>
                        </svg>
                      </label>
                    </div>
                    <label :for="i.title" class="ang-form-label">{{
                      i.title
                    }}</label>
                  </div>
                  <div
                    v-if="i.title === 'inne' && i.checked === true"
                    class="insurance-list__col-textarea"
                  >
                    <span class="insurance-list__col-right-title">Inne:</span>
                    <textarea
                      class="ang-form-control insurance-list__col-right-area"
                      name="data[apk][FirmaInne][]"
                      rows="3"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="nnw"
            v-if="insurances.includes('nnw') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">NNW</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/nnw.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <span class="insurance-list__col-right-title"
                >Objęcie ochroną:</span
              >
              <div class="form-check">
                <div
                  class="form-group d-flex"
                  v-for="(i, k) in items.nnwItems"
                  :key="k"
                >
                  <div
                    class="custom-checkbox custom-checkbox--small custom-checkbox--red"
                  >
                    <input
                      type="checkbox"
                      :id="i"
                      :value="i"
                      :name="'data[apk][NNW][]'"
                      required
                    />
                    <label :for="i">
                      <svg class="checkbox" viewbox="0 0 40 40">
                        <rect x="2" y="2" width="16" height="16"></rect>
                        <polyline points="5,8 8,14 15,5"></polyline>
                      </svg>
                    </label>
                  </div>
                  <label :for="i" class="ang-form-label">{{ i }}</label>
                </div>
              </div>
            </div>
          </div>
          <div
            id="others"
            v-if="insurances.includes('others') === true"
            class="insurance-list"
          >
            <div class="insurance-list__col-left">
              <div class="insurance-list__col-img">
                <div
                  class="ang-card-body d-flex align-items-center flex-column"
                >
                  <h4 class="ang-card-title">Inne</h4>
                  <img
                    width="100"
                    class="img-responsive"
                    src="/assets/img/apk-icons/inne.png"
                  />
                </div>
              </div>
            </div>
            <div class="insurance-list__col-right">
              <span class="insurance-list__col-right-title"
                >Określ przedmiot ochrony:</span
              >
              <div class="form-group">
                <textarea
                  class="ang-form-control insurance-list__col-right-area"
                  name="data[apk][Inne][]"
                  rows="3"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="form-group form-check d-flex flex-wrap pl-0">
          <p class="form-check-label h6 mb-4">
            Oświadczam pod rygorem odpowiedzialności karnej za złożenie
            fałszywego oświadczenia:
          </p>
          <template v-if="agree === 2 && insurances.includes('life') === true">
            <template v-if="client.company_type === 0">
              <p class="insurance-list__col-right-title">
                Jestem osobą zajmującą eksponowane stanowisko polityczne
                <span class="d-inline-block tippy-1"
                  ><svg
                    width="18"
                    height="18"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12" stroke="#591144" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.3631 10.4319C11.4121 10.2466 11.4852 10.0821 11.5819 9.93765C11.6826 9.78971 11.8095 9.66812 11.9632 9.57245C12.1162 9.48034 12.3075 9.43197 12.5413 9.43197C12.7362 9.43197 12.9028 9.46597 13.0433 9.53119L13.0463 9.53245C13.1931 9.59371 13.3152 9.68271 13.4139 9.79962C13.5126 9.91186 13.5875 10.0498 13.6357 10.2127L13.6364 10.2148C13.6897 10.3788 13.7167 10.5585 13.7167 10.7545C13.7167 11.013 13.6647 11.2518 13.5627 11.4693C13.4633 11.6918 13.3332 11.906 13.1734 12.1096C13.0166 12.3161 12.847 12.5177 12.6646 12.7142C12.4787 12.9146 12.303 13.123 12.1377 13.3388C11.9756 13.5523 11.8392 13.7796 11.7292 14.0193C11.6218 14.2598 11.5686 14.5233 11.5686 14.8086V15.723H13.0843V14.9078C13.0843 14.7302 13.1334 14.5504 13.235 14.3674C13.3399 14.1785 13.4709 13.9855 13.627 13.7901C13.7845 13.5877 13.9575 13.3776 14.146 13.1597C14.3375 12.9382 14.5139 12.7057 14.6744 12.4635C14.836 12.2145 14.9716 11.9499 15.081 11.6699C15.1923 11.3849 15.2477 11.0795 15.2477 10.7545C15.2477 10.4056 15.1979 10.0667 15.0984 9.73819C14.9981 9.40721 14.8394 9.11223 14.6223 8.85404C14.4038 8.59411 14.1223 8.3885 13.7799 8.2364C13.434 8.07765 13.0202 8 12.5413 8C12.197 8 11.8888 8.04409 11.618 8.13386C11.3554 8.21752 11.1228 8.33041 10.9208 8.47317C10.7252 8.61003 10.5569 8.76968 10.4186 8.94972C10.2881 9.12639 10.178 9.30617 10.0888 9.48908C9.87849 9.91291 9.75874 10.4025 9.72755 10.956L9.72266 11.0429H11.2495L11.2578 10.97C11.2778 10.7962 11.3129 10.6165 11.3631 10.4319Z"
                      fill="#591144"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5971 18.1891H13.1127V16.6808H11.5971V18.1891Z"
                      fill="#591144"
                    />
				</svg></span>
                lub członkiem rodziny osoby zajmującej eksponowane stanowiska
                polityczne
                <span class="d-inline-block tippy-2"
                  ><svg
                    width="18"
                    height="18"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12" stroke="#591144" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.3631 10.4319C11.4121 10.2466 11.4852 10.0821 11.5819 9.93765C11.6826 9.78971 11.8095 9.66812 11.9632 9.57245C12.1162 9.48034 12.3075 9.43197 12.5413 9.43197C12.7362 9.43197 12.9028 9.46597 13.0433 9.53119L13.0463 9.53245C13.1931 9.59371 13.3152 9.68271 13.4139 9.79962C13.5126 9.91186 13.5875 10.0498 13.6357 10.2127L13.6364 10.2148C13.6897 10.3788 13.7167 10.5585 13.7167 10.7545C13.7167 11.013 13.6647 11.2518 13.5627 11.4693C13.4633 11.6918 13.3332 11.906 13.1734 12.1096C13.0166 12.3161 12.847 12.5177 12.6646 12.7142C12.4787 12.9146 12.303 13.123 12.1377 13.3388C11.9756 13.5523 11.8392 13.7796 11.7292 14.0193C11.6218 14.2598 11.5686 14.5233 11.5686 14.8086V15.723H13.0843V14.9078C13.0843 14.7302 13.1334 14.5504 13.235 14.3674C13.3399 14.1785 13.4709 13.9855 13.627 13.7901C13.7845 13.5877 13.9575 13.3776 14.146 13.1597C14.3375 12.9382 14.5139 12.7057 14.6744 12.4635C14.836 12.2145 14.9716 11.9499 15.081 11.6699C15.1923 11.3849 15.2477 11.0795 15.2477 10.7545C15.2477 10.4056 15.1979 10.0667 15.0984 9.73819C14.9981 9.40721 14.8394 9.11223 14.6223 8.85404C14.4038 8.59411 14.1223 8.3885 13.7799 8.2364C13.434 8.07765 13.0202 8 12.5413 8C12.197 8 11.8888 8.04409 11.618 8.13386C11.3554 8.21752 11.1228 8.33041 10.9208 8.47317C10.7252 8.61003 10.5569 8.76968 10.4186 8.94972C10.2881 9.12639 10.178 9.30617 10.0888 9.48908C9.87849 9.91291 9.75874 10.4025 9.72755 10.956L9.72266 11.0429H11.2495L11.2578 10.97C11.2778 10.7962 11.3129 10.6165 11.3631 10.4319Z"
                      fill="#591144"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5971 18.1891H13.1127V16.6808H11.5971V18.1891Z"
                      fill="#591144"
                    />
					</svg>
				</span>
                lub osobą znaną jako bliski współpracownik osoby zajmującej
                eksponowane stanowiska polityczne
                <span class="d-inline-block tippy-3">
				<svg
                    width="18"
                    height="18"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12" stroke="#591144" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.3631 10.4319C11.4121 10.2466 11.4852 10.0821 11.5819 9.93765C11.6826 9.78971 11.8095 9.66812 11.9632 9.57245C12.1162 9.48034 12.3075 9.43197 12.5413 9.43197C12.7362 9.43197 12.9028 9.46597 13.0433 9.53119L13.0463 9.53245C13.1931 9.59371 13.3152 9.68271 13.4139 9.79962C13.5126 9.91186 13.5875 10.0498 13.6357 10.2127L13.6364 10.2148C13.6897 10.3788 13.7167 10.5585 13.7167 10.7545C13.7167 11.013 13.6647 11.2518 13.5627 11.4693C13.4633 11.6918 13.3332 11.906 13.1734 12.1096C13.0166 12.3161 12.847 12.5177 12.6646 12.7142C12.4787 12.9146 12.303 13.123 12.1377 13.3388C11.9756 13.5523 11.8392 13.7796 11.7292 14.0193C11.6218 14.2598 11.5686 14.5233 11.5686 14.8086V15.723H13.0843V14.9078C13.0843 14.7302 13.1334 14.5504 13.235 14.3674C13.3399 14.1785 13.4709 13.9855 13.627 13.7901C13.7845 13.5877 13.9575 13.3776 14.146 13.1597C14.3375 12.9382 14.5139 12.7057 14.6744 12.4635C14.836 12.2145 14.9716 11.9499 15.081 11.6699C15.1923 11.3849 15.2477 11.0795 15.2477 10.7545C15.2477 10.4056 15.1979 10.0667 15.0984 9.73819C14.9981 9.40721 14.8394 9.11223 14.6223 8.85404C14.4038 8.59411 14.1223 8.3885 13.7799 8.2364C13.434 8.07765 13.0202 8 12.5413 8C12.197 8 11.8888 8.04409 11.618 8.13386C11.3554 8.21752 11.1228 8.33041 10.9208 8.47317C10.7252 8.61003 10.5569 8.76968 10.4186 8.94972C10.2881 9.12639 10.178 9.30617 10.0888 9.48908C9.87849 9.91291 9.75874 10.4025 9.72755 10.956L9.72266 11.0429H11.2495L11.2578 10.97C11.2778 10.7962 11.3129 10.6165 11.3631 10.4319Z"
                      fill="#591144"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.5971 18.1891H13.1127V16.6808H11.5971V18.1891Z"
                      fill="#591144"
                    />
				</svg>
			</span>
              </p>
              <div class="d-flex w-100">
                <div class="form-group d-flex mr-2">
                  <div
                    class="custom-checkbox custom-checkbox--small custom-checkbox--purple"
                  >
                    <input
                      type="radio"
                      v-model="position"
                      id="criminalResponsibilityNo"
                      value="Nie"
                      :name="'data[apk][beneficients][0][has_position]'"
                      required
                    />
                    <label for="criminalResponsibilityNo">
                      <svg class="checkbox" viewbox="0 0 40 40">
                        <rect x="2" y="2" width="16" height="16"></rect>
                        <polyline points="5,8 8,14 15,5"></polyline>
                      </svg>
                    </label>
                  </div>
                  <label
                    for="criminalResponsibilityNo"
                    class="ang-form-label"
                    style="margin-top: 1px"
                    >Nie</label
                  >
                </div>
                <div class="form-group d-flex">
                  <div
                    class="custom-checkbox custom-checkbox--small custom-checkbox--purple"
                  >
                    <input
                      type="radio"
                      v-model="position"
                      id="criminalResponsibilityYes"
                      value="Tak"
                      :name="'data[apk][beneficients][0][has_position]'"
                      required
                    />
                    <label for="criminalResponsibilityYes">
                      <svg class="checkbox" viewbox="0 0 40 40">
                        <rect x="2" y="2" width="16" height="16"></rect>
                        <polyline points="5,8 8,14 15,5"></polyline>
                      </svg>
                    </label>
                  </div>
                  <label
                    for="criminalResponsibilityYes"
                    class="ang-form-label"
                    style="margin-top: 1px"
                    >Tak</label
                  >
                </div>
              </div>
              <template v-if="position === 'Tak'">
                <div class="d-flex flex-col mb-4">
                  <p class="insurance-list__col-right-title">
                    A. Rodzaj zajmowanego stanowiska lub stopień pokrewieństwa
                    bądź relacji z osobą zajmującą eksponowane stanowisko
                    polityczne (PEP):
                  </p>
                  <input
                    type="text"
                    class="ang-form-control ang-form-control-position-held"
                    id="positionHeld"
                    name="data[apk][beneficients][0][position]"
                    required
                  />
                </div>
                <div class="d-flex flex-col mb-4 w-100">
                  <div
                    class="relative d-flex justify-between items-center w-100"
                    @click="expanded = !expanded"
                  >
                    <p class="insurance-list__col-right-title">
                      B. Źródło pochodzenia majątku (należy rozwinąć i wybrać
                      właściwą opcję - można wybrać więcej niż jedną opcję)
                    </p>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      style="transition: 0.3s all ease-in-out"
                      :class="{ 'chevron-transform': this.expanded }"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                  <div
                    class="justify-content-center mt-1 mb-1"
                    :class="{ 'd-none': expanded, 'd-flex': !expanded }"
                  >
                    <p
                      class="font-weight-bold"
                      @click="expanded = !expanded"
                      style="color: #ffd433"
                    >
                      (Rozwiń Opcje)
                    </p>
                  </div>
                  <div class="ang-accordion" :class="{ show: this.expanded }">
                    <div v-for="(i, k) in items.majatekItems" :key="k">
                      <div class="form-group d-flex mt-1">
                        <div
                          class="custom-checkbox custom-checkbox--small custom-checkbox--yellow"
                        >
                          <input
                            v-model="i.checked"
                            type="checkbox"
                            :id="i.title"
                            :value="i.title"
                            :name="'data[apk][beneficients][0][source_of_funds][]'"
                          />
                          <label :for="i.title">
                            <svg class="checkbox" viewbox="0 0 40 40">
                              <rect x="2" y="2" width="16" height="16"></rect>
                              <polyline points="5,8 8,14 15,5"></polyline>
                            </svg>
                          </label>
                        </div>
                        <label :for="i.title" class="ang-form-label">{{
                          i.title
                        }}</label>
                      </div>
                      <div
                        v-if="
                          i.title === 'działalność gospodarcza' &&
                          i.checked === true
                        "
                        class="insurance-list__col-textarea mb-4"
                      >
                        <span class="insurance-list__col-right-title"
                          >Działalność gospodarcza, Proszę podać jej przedmiot
                          (branżę):</span
                        >
                        <textarea
                          class="ang-form-control insurance-list__col-right-area"
                          name="data[apk][beneficients][0][source_of_funds][jdg]"
                          rows="3"
                        />
                      </div>
                      <div
                        v-if="i.title === 'inne źródło' && i.checked === true"
                        class="insurance-list__col-textarea"
                      >
                        <span class="insurance-list__col-right-title"
                          >Inne, Proszę podać, o jakie źródło chodzi:</span
                        >
                        <textarea
                          class="ang-form-control insurance-list__col-right-area"
                          name="data[apk][beneficients][0][source_of_funds][others]"
                          rows="3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-col mb-4 w-100">
                  <div
                    class="relative d-flex justify-between items-center w-100"
                    @click="expandedSec = !expandedSec"
                  >
                    <p class="insurance-list__col-right-title">
                      C. Źródło pochodzenia środków na finansowanie składki
                      (należy rozwinąć wybrać właściwą opcję - można wybrać
                      więcej niż jedną opcję):
                    </p>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      style="transition: 0.3s all ease-in-out"
                      :class="{ 'chevron-transform': this.expandedSec }"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                  <div
                    class="justify-content-center mt-1 mb-1"
                    :class="{ 'd-none': expandedSec, 'd-flex': !expandedSec }"
                  >
                    <p
                      class="font-weight-bold"
                      @click="expandedSec = !expandedSec"
                      style="color: #1191aa"
                    >
                      (Rozwiń Opcje)
                    </p>
                  </div>
                  <div
                    class="ang-accordion"
                    :class="{ show: this.expandedSec }"
                  >
                    <div v-for="(j, k) in items.majatekItems" :key="k">
                      <div class="form-group d-flex mt-1">
                        <div
                          class="custom-checkbox custom-checkbox--small custom-checkbox--blue"
                        >
                          <input
                            v-model="j.check"
                            type="checkbox"
                            :id="j.title + ' Finansowanie'"
                            :value="j.title"
                            :name="'data[apk][beneficients][0][source_of_financing][]'"
                          />
                          <label :for="j.title + ' Finansowanie'">
                            <svg class="checkbox" viewbox="0 0 40 40">
                              <rect x="2" y="2" width="16" height="16"></rect>
                              <polyline points="5,8 8,14 15,5"></polyline>
                            </svg>
                          </label>
                        </div>
                        <label
                          :for="j.title + ' Finansowanie'"
                          class="ang-form-label"
                          >{{ j.title }}</label
                        >
                      </div>
                      <div
                        v-if="
                          j.title === 'działalność gospodarcza' &&
                          j.check === true
                        "
                        class="insurance-list__col-textarea mb-4"
                      >
                        <span class="insurance-list__col-right-title"
                          >Działalność gospodarcza, Proszę podać jej przedmiot
                          (branżę):</span
                        >
                        <textarea
                          class="ang-form-control insurance-list__col-right-area"
                          name="data[apk][beneficients][0][source_of_financing][jdg]"
                          rows="3"
                        />
                      </div>
                      <div
                        v-if="j.title === 'inne źródło' && j.check === true"
                        class="insurance-list__col-textarea"
                      >
                        <span class="insurance-list__col-right-title"
                          >Inne, Proszę podać, o jakie źródło chodzi:</span
                        >
                        <textarea
                          class="ang-form-control insurance-list__col-right-area"
                          name="data[apk][beneficients][0][source_of_financing][others]"
                          rows="3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div v-for="(i, key) in beneficiaries" :key="key" class="row">
                <div class="col-sm-12">
                  <h5
                    v-show="beneficiaries.length > 1 && key > 0"
                    class="beneficiaries-title mb-4 my-4"
                  >
                    Dane kolejnego beneficjenta:
                  </h5>
                  <p class="insurance-list__col-right-title">
                    Oświadczam, że beneficjentami rzeczywistymi
                    <span
                      v-if="beneficiaries.length > 0 && key < 1"
                      class="d-inline-block tippy-4"
                      ><svg
                        width="18"
                        height="18"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12.5" cy="12.5" r="12" stroke="#591144" />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.3631 10.4319C11.4121 10.2466 11.4852 10.0821 11.5819 9.93765C11.6826 9.78971 11.8095 9.66812 11.9632 9.57245C12.1162 9.48034 12.3075 9.43197 12.5413 9.43197C12.7362 9.43197 12.9028 9.46597 13.0433 9.53119L13.0463 9.53245C13.1931 9.59371 13.3152 9.68271 13.4139 9.79962C13.5126 9.91186 13.5875 10.0498 13.6357 10.2127L13.6364 10.2148C13.6897 10.3788 13.7167 10.5585 13.7167 10.7545C13.7167 11.013 13.6647 11.2518 13.5627 11.4693C13.4633 11.6918 13.3332 11.906 13.1734 12.1096C13.0166 12.3161 12.847 12.5177 12.6646 12.7142C12.4787 12.9146 12.303 13.123 12.1377 13.3388C11.9756 13.5523 11.8392 13.7796 11.7292 14.0193C11.6218 14.2598 11.5686 14.5233 11.5686 14.8086V15.723H13.0843V14.9078C13.0843 14.7302 13.1334 14.5504 13.235 14.3674C13.3399 14.1785 13.4709 13.9855 13.627 13.7901C13.7845 13.5877 13.9575 13.3776 14.146 13.1597C14.3375 12.9382 14.5139 12.7057 14.6744 12.4635C14.836 12.2145 14.9716 11.9499 15.081 11.6699C15.1923 11.3849 15.2477 11.0795 15.2477 10.7545C15.2477 10.4056 15.1979 10.0667 15.0984 9.73819C14.9981 9.40721 14.8394 9.11223 14.6223 8.85404C14.4038 8.59411 14.1223 8.3885 13.7799 8.2364C13.434 8.07765 13.0202 8 12.5413 8C12.197 8 11.8888 8.04409 11.618 8.13386C11.3554 8.21752 11.1228 8.33041 10.9208 8.47317C10.7252 8.61003 10.5569 8.76968 10.4186 8.94972C10.2881 9.12639 10.178 9.30617 10.0888 9.48908C9.87849 9.91291 9.75874 10.4025 9.72755 10.956L9.72266 11.0429H11.2495L11.2578 10.97C11.2778 10.7962 11.3129 10.6165 11.3631 10.4319Z"
                          fill="#591144"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.5971 18.1891H13.1127V16.6808H11.5971V18.1891Z"
                          fill="#591144"
                        />
					</svg>
				</span>
                    osoby prawnej lub jednostki organizacyjnej niebędącej osobą
                    prawną będącej Ubezpieczającym/ uprawnionym z umowy
                    ubezpieczenia są:
                  </p>
                </div>
                <div
                  class="mb-2 mb-md-0"
                  :class="{
                    'col-sm-9 col-md-5': beneficiaries.length > 1 && key > 0,
                    'col-sm-12 col-md-6': key === 0,
                  }"
                >
                  <input
                    type="text"
                    class="ang-form-control"
                    :id="key"
                    :name="'data[apk][beneficients][' + key + '][name]'"
                    placeholder="Imię"
                    required
                  />
                </div>
                <div
                  class="mb-2 mb-md-0"
                  :class="{
                    'col-sm-9 col-md-5': beneficiaries.length > 1 && key > 0,
                    'col-sm-12 col-md-6': key === 0,
                  }"
                >
                  <input
                    type="text"
                    class="ang-form-control"
                    :name="'data[apk][beneficients][' + key + '][last_name]'"
                    placeholder="Nazwisko"
                    required
                  />
                </div>
                <div class="col-sm-3 col-md-2 d-flex align-items-center">
                  <button
                    v-show="beneficiaries.length > 1 && key > 0"
                    class="btn ang-button ang-btn-small ang-button-minus ml-md-4 pl-3 pr-4 mt-md-0"
                    @click.stop.prevent="removeBeneficiaryMember(key)"
                  >
                    Usuń
                  </button>
                </div>
                <div class="col-12 mt-4">
                  <p class="insurance-list__col-right-title">
                    Ww. beneficjent rzeczywisty jest osobą zajmującą eksponowane
                    stanowisko polityczne lub członkiem rodziny osoby zajmującej
                    eksponowane stanowisko polityczne lub osobą znaną jako
                    bliski współpracownik osoby zajmującej eksponowane
                    stanowisko polityczne:
                  </p>
                  <div class="d-flex w-100">
                    <div class="form-group d-flex mb-1 mr-2">
                      <div
                        class="custom-checkbox custom-checkbox--small custom-checkbox--purple"
                      >
                        <input
                          type="radio"
                          :id="'beneficiaryPositionNo' + key"
                          value="nie"
                          :name="
                            'data[apk][beneficients][' + key + '][has_position]'
                          "
                          v-model="i.checked"
                          required
                        />
                        <label :for="'beneficiaryPositionNo' + key">
                          <svg class="checkbox" viewbox="0 0 40 40">
                            <rect x="2" y="2" width="16" height="16"></rect>
                            <polyline points="5,8 8,14 15,5"></polyline>
                          </svg>
                        </label>
                      </div>
                      <label
                        :for="'beneficiaryPositionNo' + key"
                        class="ang-form-label"
                        style="margin-top: 1px"
                        >Nie</label
                      >
                    </div>
                    <div class="form-group d-flex mb-1">
                      <div
                        class="custom-checkbox custom-checkbox--small custom-checkbox--purple"
                      >
                        <input
                          type="radio"
                          :id="'beneficiaryPositionYes' + key"
                          value="tak"
                          :name="
                            'data[apk][beneficients][' + key + '][has_position]'
                          "
                          v-model="i.checked"
                          required
                        />
                        <label :for="'beneficiaryPositionYes' + key">
                          <svg class="checkbox" viewbox="0 0 40 40">
                            <rect x="2" y="2" width="16" height="16"></rect>
                            <polyline points="5,8 8,14 15,5"></polyline>
                          </svg>
                        </label>
                      </div>
                      <label
                        :for="'beneficiaryPositionYes' + key"
                        class="ang-form-label"
                        style="margin-top: 1px"
                        >Tak</label
                      >
                    </div>
                  </div>
                </div>
                <div v-show="i.checked === 'tak'" class="col-12 mb-4">
                  <p class="insurance-list__col-right-title">
                    Proszę wskazać rodzaj zajmowanego stanowiska lub stopień
                    pokrewieństwa bądź relacji z osobą zajmującą eksponowane
                    stanowisko polityczne:
                  </p>
                  <input
                    type="text"
                    class="ang-form-control ang-form-control-position-held"
                    placeholder="Rodzaj zajmowanego stanowiska lub stopień pokrewieństwa"
                    :name="'data[apk][beneficients][' + key + '][position]'"
                    :required="i.checked === 'tak'"
                  />
                </div>
              </div>
              <div class="mb-5 mt-1">
                <button
                  class="ang-button ang-btn-lg"
                  @click.stop.prevent="addBeneficiaryMember"
                >
                  Dodaj kolejnego beneficjenta
                </button>
              </div>
            </template>
          </template>
        </div>
        <div class="requirements">
          <!--          <div v-if="agree === 2" class="form-group form-check d-flex flex-wrap">-->
          <!--            <input type="hidden" name="is_agreed" value="1"/>-->
          <!--            <input id="interests" type="checkbox" class="form-check-input" value="1" name="data[apk][accept]" required/>-->
          <!--            <label for="interests" class="form-check-label ang-consent"><span class="mr-1">*</span>Oświadczam, że jestem zainteresowany wyłącznie wskazanymi-->
          <!--              powyżej zakresami ubezpieczenia. Jednocześnie oświadczam, że nie jestem zainteresowany ofertami ubezpieczeniowymi-->
          <!--              obejmującymi inne, niż wskazane powyżej zakresy ubezpieczenia.</label>-->
          <!--          </div>          -->
          <div
            v-if="agree === 2"
            class="form-group form-check d-flex flex-wrap"
          >
            <input type="hidden" name="is_agreed" value="1" />
            <input
              id="interests"
              type="checkbox"
              class="form-check-input"
              value="1"
              name="data[apk][accept]"
              required
            />
            <label for="interests" class="form-check-label ang-consent"
              ><span class="mr-1">*</span> Oświadczam, że przed zawarciem umowy
              ubezpieczenia dystrybutor przeprowadził analizę moich potrzeb i
              wymagań (zwane APK), dotyczących poszukiwanej przeze mnie ochrony
              ubezpieczeniowej. Ponadto oświadczam, że przed przystąpieniem do
              APK zostałem poinformowany przez dystrybutora, iż zakres
              udzielonych przeze mnie informacji będzie miał wpływ na propozycje
              produktów ubezpieczeniowych. Jednocześnie oświadczam, że przed
              zawarciem umowy ubezpieczenia lub umowy gwarancji ubezpieczeniowej
              otrzymałem następujące informacje:
              <ol class="apk-list">
                <li>
                  o firmie, pod którą agent wykonuje działalność agencyjną,
                  adresie jego siedziby oraz o tym, że jest agentem
                  ubezpieczeniowym;
                </li>
                <li>
                  o numerze wpisu ANG Odpowiedzialne Finanse S.A. do rejestru
                  agentów, adresie strony internetowej, na której rejestr jest
                  dostępny, oraz o sposobie sprawdzenia wpisu do rejestru;
                </li>
                <li>
                  o tym, że agent działa na rzecz wielu zakładów ubezpieczeń;
                </li>
                <li>
                  o firmach zakładów ubezpieczeń, na rzecz których agent
                  wykonuje działalność agencyjną;
                </li>
                <li>
                  o charakterze wynagrodzenia otrzymywanego w związku z
                  proponowanym zawarciem umowy ubezpieczenia lub umowy gwarancji
                  ubezpieczeniowej;
                </li>
                <li>
                  o możliwości złożenia reklamacji, wniesienia skargi oraz
                  pozasądowego rozwiązywania sporów;
                </li>
                <li>
                  zostały mi udostępnione dokumenty pełnomocnictw udzielonych
                  agentowi - ANG Odpowiedzialne Finanse S.A. przez zakłady
                  ubezpieczeń, upoważniające agenta do zawierania umów
                  ubezpieczenia lub umów gwarancji ubezpieczeniowych, w imieniu
                  zakładów ubezpieczeń.
                </li>
              </ol>
            </label>
          </div>
          <div
            v-if="agree === 0"
            class="form-group form-check d-flex flex-wrap"
          >
            <input type="hidden" name="is_agreed" value="0" />
            <input
              id="decline"
              class="form-check-input"
              type="checkbox"
              value="1"
              name="data[apk][decline]"
              required
            />
            <label
              for="decline"
              class="form-check-label ang-consent"
              style="margin-top: 3px"
            >
              <span class="mr-1">*</span>Odmawiam wypełnienia analizy potrzeb.
              Jednocześnie zostałem poinformowany, że w przypadku odmowy nie
              zostanie mi przedstawiona oferta ubezpieczeniowa.
            </label>
          </div>
          <div
            v-if="agree === 0"
            class="form-group form-check d-flex flex-wrap m-0 p-0"
          >
            <input
              id="reset"
              type="checkbox"
              name="reset"
              value="1"
              style="display: none"
            />
          </div>
          <!--          <div class="form-group form-check d-flex flex-wrap">-->
          <!--            <input id="needs" class="form-check-input" type="checkbox" value="1" name="data[apk][needs]" required/>-->
          <!--            <label for="needs" class="form-check-label ang-consent"><span class="mr-1">*</span>-->
          <!--              Oświadczam, że akceptacja przedstawionej mi oferty ubezpieczeniowej oznacza, iż w pełni odpowiada ona moim potrzebom ubezpieczeniowym oraz że-->
          <!--              zostały mi przedstawione i udostępnione informacje o wszystkich istotnych cechach produktu.-->
          <!--            </label>-->
          <!--          </div>-->
          <div class="form-group form-check d-flex flex-wrap mb-4">
            <input
              id="is_online_offer"
              class="form-check-input"
              type="checkbox"
              value="1"
              name="is_online_offer"
              required
            />
            <label
              for="is_online_offer"
              class="form-check-label ang-consent"
              style="margin-top: 2px"
              ><span class="mr-1">*</span>Oświadczam, że chcę otrzymać
              informację o agencie oraz o produkcie ubezpieczeniowym za pomocą
              trwałego nośnika, w postaci elektronicznej na mój adres e-mail,
              udostępniony
              <a target="_blank" href="https://angfinanse.pl/"
                >ANG Odpowiedzialne Finanse S.A.</a
              >oraz za pośrednictwem strony internetowej, w związku z
              posiadaniem przeze mnie regularnego dostępu do internetu
            </label>
          </div>
          <div v-if="!codeSend" class="row mb-5 sms-section">
            <div class="col-12">
              <p class="mb-2 mt-4">
                Twoją analizę musisz zatwierdzić kodem, który wyślemy do Ciebie
                w wiadomości SMS.
              </p>
              <button
                @click.prevent="sendSMS()"
                id="sendSMS"
                class="send-spinn btn ang-button ang-btn-lg"
              >
                Wyślij kod
              </button>
            </div>
          </div>
          <div v-if="codeSend" class="row">
            <div class="col-12">
              <p class="p-0 mt-4">
                Na Twój numer telefonu wysłaliśmy wiadomość SMS z kodem służącym
                do zatwierdzenia niniejszej ankiety.
              </p>
              <div
                class="alert alert-warning ang-alert-warning mb-3"
                role="alert"
              >
                <h5 class="ang-card-title">Uwaga!</h5>
                Masz tylko <span style="font-weight: 700">15 minut</span> na
                potwierdzenie swoich danych. Jeżeli w ciągu 15 minut nie
                potwierdzisz swoich danych zostaną one skasowane z naszych baz
                danych.
              </div>
            </div>
          </div>
          <div v-if="codeSend" class="row mb-5">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label class="ang-form-label" for="code"
                  >Kod potwierdzający</label
                >
                <input
                  type="text"
                  class="ang-form-control"
                  id="code"
                  name="code"
                  required
                />
              </div>
            </div>
          </div>
          <div
            v-if="error && codeSend"
            class="alert alert-danger ang-alert-danger mt-3"
          >
            <h5 class="ang-card-title">Wystąpił błąd!</h5>
            <label class="form-error error">{{ error }}</label>
          </div>
        </div>
        <div
          v-if="agree === 2 || agree === 0"
          class="buttons-wrapper"
          :class="{
            'justify-content-end': agree === 0,
            'justify-content-between': agree === 2,
          }"
        >
          <div
            v-if="agree === 2"
            class="btn ang-button ang-btn-lg _bg_color3"
            @click.stop.prevent="$emit('backward')"
          >
            Wstecz
          </div>
          <div v-if="codeSend">
            <spinner v-if="sending"></spinner>
            <button
              v-else
              type="submit"
              class="btn ang-button ang-btn-lg spinn"
            >
              Zapisz i zakończ
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import spinner from "@/components/partials/misc/spinner";
import select from "@/components/partials/misc/select";
import $ from "jquery";
import tippy from "tippy.js";
import ajax from "@/services/ajax";
import api from "@/services/api";

export default {
  data() {
    return {
      loading: false,
      codeSend: false,
      sending: false,
      expanded: true,
      expandedSec: false,
      position: null,
      error: null,
      hiddenPropertyOptions: null,
      hiddenTravelOptions: null,
      selectedCompany: [],
      selectedInsurances: [],
      beneficiaries: [{}],
      selectedOc: false,
      items: {
        samochodItems: [
          "OC",
          "AC",
          "ASSISTANCE",
          "NNW",
          "Dodatkowe ryzyka (np. Szyby, GAP)",
        ],
        domItems: {
          subject: [
            "Dom",
            "Dom w budowie",
            "Mieszkanie",
            "Dom letniskowy",
          ],
          range: [
			{ 
				value: "All Risk (wszystkie ryzyka)", 
				label: "All Risk (wszystkie ryzyka)"
			},
			{
				value: "Wybrane ryzyka (np. ogień, zalanie, przepięcia)",
				label: "Wybrane ryzyka (np. ogień, zalanie, przepięcia)"
			},
			{
				value: "Wyposazenie",
				label: "Ruchomości domowe i wyposażenie"
			},
			{
				value: "Rozbiorka",
				label: "Nieruchomość opuszczona lub przeznaczona do rozbiórki"
			},
			{
				value: "OC prywatne", 
				label: "OC prywatne"
			},
          ],
          destiny: ["Prywatne", "Wynajem", "Działalność gospodarcza"],
        },
        turystykaItems: {
          subject: ["Wypoczynek", "Sport", "Praca zarobkowa"],
          range: [
            "Koszty leczenia",
            "Uszczerbek na zdrowiu",
            "Rozszerzenie ochrony o choroby przewlekłe",
            "Bagaż podróżny",
            "OC w życiu prywatnym",
            "Koszty rezygnacji z podróży",
          ],
          direction: ["Polska", "Europa", "Świat"],
        },
        rolneItems: ["Obowiązkowe", "Uprawy", "Zwierzęta", "Maszyny"],
        zdrowotneItems: [
          "Pakiet indywidualny",
          "Pakiet rodzinny",
          "Pakiet dla firm",
        ],
        nnwItems: ["Osoba dorosła", "Dziecko", "Sport"],
        ocItems: {
          values: [
            { val: "Biegły rewident", text: "Biegły rewident" },
            { val: "Biuro usług płatniczych", text: "Biuro usług płatniczych" },
            { val: "Detektyw", text: "Detektyw" },
            { val: "Inżynier budownictwa", text: "Inżynier budownictwa" },
            { val: "Komornik sądowy", text: "Komornik sądowy" },
            { val: "Księgowy", text: "Księgowy" },
            { val: "Lekarz", text: "Lekarz" },
            { val: "Notariusz", text: "Notariusz" },
            {
              val: "Organizator imprez masowych",
              text: "Organizator imprez masowych",
            },
            { val: "Placówka zdrowotna", text: "Placówka zdrowotna" },
            { val: "Pośrednik nieruchomości", text: "Pośrednik nieruchomości" },
            {
              val: "Pośrednik ubezpieczeniowy",
              text: "Pośrednik ubezpieczeniowy",
            },
            { val: "Przewoźnik / Spedytor", text: "Przewoźnik / Spedytor" },
            { val: "Radca prawny", text: "Radca prawny" },
            { val: "Rzecznik patentowy", text: "Rzecznik patentowy" },
            { val: "Rzeczoznawca majątkowy", text: "Rzeczoznawca majątkowy" },
            { val: "Usługi medyczne", text: "Usługi medyczne" },
            { val: "Zarządca nieruchomości", text: " Zarządca nieruchomości" },
            { val: "Inne", text: "Inne" },
          ],
        },
        zycieItems: [
          "Utrata życia",
          "Ochrona zdrowia",
          "Ochrona dziecka",
          "Oszczędzanie",
        ],
        firmaItems: [
          { title: "mienie i wyposażenie" },
          { title: "OC działalności" },
          { title: "gwarancje" },
          { title: "ryzyka budowlano-montażowe" },
          { title: "prawno-skarbowe" },
          { title: "cyber ubezpieczenia" },
          { title: "inne" },
        ],
        majatekItems: [
          { title: "praca zarobkowa (np. umowa o pracę, zlecenia)" },
          { title: "spadek/darowizna/zapis" },
          { title: "wygrana w grach losowych" },
          {
            title:
              "zyski kapitałowe / dywidendy / sprzedaż papierów wartościowych",
          },
          { title: "sprzedaż nieruchomości" },
          { title: "umowy najmu/wynajmu" },
          { title: "emerytura / renty/ dochody rentierskie" },
          { title: "odszkodowania" },
          { title: "umowy o dzieło" },
          { title: "prawa autorskie i prawa pokrewne" },
          { title: "prawa własności przemysłowej oraz inne prawa twórcy" },
          { title: "oszczędności" },
          { title: "działalność gospodarcza" },
          { title: "inne źródło" },
        ],
      },
    };
  },
  name: "insuranceTypesList",
  props: ["agree", "insurances", "client", "uid", "base", "prevent"],
  components: {
    spinner,
    "select-field": select,
  },
  computed: {
    action: function () {
      return "/clients/" + this.base + "/analysis";
    },
  },
  methods: {
    sendSMS: function () {
      let self = this;
      $(".sms-error").html("");
      $("#sendSMS").html(
        '<img src="/assets/img/three-dots.svg" width="40" alt="">'
      );
      let params = {};
      if (this.prevent) {
        params.notify = 0;
      } else {
        params.notify = 1;
      }
      api.post(
        "/api/client/" + this.base + "/apksms",
        params,
        function () {
          self.codeSend = true;
          $("#sendSMS").hide();
          $("#sendSMS").html("Wyślij kod");
        },
        function (data) {
          console.log(data);
          $("#sendSMS").html("Wyślij kod");
          $(".sms-error").html("");
        }
      );
    },
    tippy() {
      tippy(".tippy-1", {
        content:
          "<p>Przez „osoba zajmująca eksponowane stanowiska polityczne” rozumie się następujące osoby fizyczne:</p>" +
          '<ol class="alpha-list">' +
          "<li>Szefów państw, szefów rządów, ministrów, wiceministrów, sekretarzy stanu, podsekretarzy stanu, w tym Prezydenta Rzeczypospolitej Polskiej, Prezesa Rady Ministrów i wiceprezesa Rady Ministrów</li>" +
          "<li>Członków parlamentu lub podobnych organów ustawodawczych, w tym posłów i senatorów</li>" +
          "<li>Członków organów zarządzających partii politycznych</li>" +
          "<li>Członków sądów najwyższych, trybunałów konstytucyjnych oraz innych organów sądowych wysokiego szczebla, których decyzje nie podlegają zaskarżeniu, z wyjątkiem trybów nadzwyczajnych, w tym sędziów Sądu Najwyższego, Trybunału Konstytucyjnego, Naczelnego Sądu Administracyjnego, wojewódzkich sądów administracyjnych oraz sędziów sądów apelacyjnych</li>" +
          "<li>Członków trybunałów obrachunkowych lub zarządów banków centralnych, w tym Prezesa oraz członków Zarządu NBP</li>" +
          "<li>Ambasadorów, charges d’affaires oraz wyższych oficerów sił zbrojnych</li>" +
          "<li>Członków organów administracyjnych, zarządczych lub nadzorczych przedsiębiorstw państwowych, w tym dyrektorów przedsiębiorstw państwowych oraz członków zarządów i rad nadzorczych spółek z udziałem Skarbu Państwa, w których ponad połowa akcji albo udziałów należy do Skarby Państwa lub innych państwowych osób prawnych</li>" +
          "<li>Dyrektorów generalnych w urzędach naczelnych i centralnych organów państwowych, dyrektorów generalnych urzędów wojewódzkich oraz kierowników urzędów terenowych organów rządowej administracj</li>" +
          "</ol>",
        allowHTML: true,
        maxWidth: "68em",
      }),
        tippy(".tippy-2", {
          content:
            "<p>Przez „członka rodziny osoby zajmującej eksponowane stanowisko polityczne” rozumie się:</p>" +
            '<ol class="alpha-list">' +
            "<li>Małżonka lub osobę pozostającą we wspólnym pożyciu z osobą zajmującą eksponowane stanowisko polityczne</li>" +
            "<li>Dziecko osoby zajmującej eksponowane stanowisko polityczne i jego małżonka lub osoby pozostającej we wspólnym pożyciu</li>" +
            "<li>Rodziców osoby zajmującej eksponowane stanowisko polityczne</li>" +
            "</ol>",
          allowHTML: true,
          maxWidth: "40em",
        }),
        tippy(".tippy-3", {
          content:
            "<p>Przez „osoba znana, jako bliski współpracownik osoby zajmującej eksponowane stanowisko polityczne” rozumie się osoby fizyczne:</p>" +
            '<ol class="alpha-list">' +
            "<li>Osoby fizyczne będące beneficjentami rzeczywistymi osób prawnych, jednostek organizacyjnych nieposiadających osobowości prawnej lub trustów wspólnie z osobą zajmującą eksponowane stanowisko polityczne lub utrzymujące z taką osobą inne bliskie stosunki związane z prowadzoną działalnością gospodarczą</li>" +
            "<li>Osoby fizyczne będące jednym beneficjentem rzeczywistym osób prawnych, jednostek organizacyjnych nieposiadających osobowości prawnej lub trustu, o których wiadomo, że zostały utworzone w celu uzyskania faktycznej korzyści przez osobę zajmującą eksponowane stanowisko polityczne</li>" +
            "</ol>",
          allowHTML: true,
          maxWidth: "40em",
        }),
        tippy(".tippy-4", {
          content:
            "<p>Beneficjent rzeczywisty: rozumie się przez to każdą osobę fizyczną sprawującą bezpośrednio lub pośrednio kontrolę nad klientem poprzez posiadane uprawnienia, które wynikają z okoliczności prawnych lub faktycznych, umożliwiające wywieranie decydującego wpływu na czynności lub działania podejmowane przez klienta, lub każdą osobę fizyczną, w imieniu której są nawiązywane stosunki gospodarcze lub jest przeprowadzana transakcja okazjonalna, w tym:</p>" +
            '<ol class="alpha-list">' +
            "<li> w przypadku osoby prawnej innej niż spółka, której papiery wartościowe są dopuszczone do obrotu na rynku regulowanym podlegającym wymogom ujawniania informacji wynikającym z przepisów prawa Unii Europejskiej lub odpowiadających im przepisów prawa państwa trzeciego: – osobę fizyczną będącą udziałowcem lub akcjonariuszem, której przysługuje prawo własności więcej niż 25% ogólnej liczby udziałów lub akcji tej osoby prawnej, – osobę fizyczną dysponującą więcej niż 25% ogólnej liczby głosów w organie stanowiącym tej osoby prawnej, także jako zastawnik albo użytkownik, lub na podstawie porozumień z innymi uprawnionymi do głosu, – osobę fizyczną sprawującą kontrolę nad osobą prawną lub osobami prawnymi, którym łącznie przysługuje prawo własności więcej niż 25% ogólnej liczby udziałów lub akcji, lub które łącznie dysponują więcej niż 25% ogólnej liczby głosów w organie stanowiącym tej osoby prawnej, także jako zastawnik albo użytkownik, lub na podstawie porozumień z innymi uprawnionymi do głosu, – osobę fizyczną sprawującą kontrolę nad osobą prawną poprzez posiadanie uprawnień, o których mowa w art. 3 ust. 1 pkt 37 ustawy z dnia 29 września 1994 r. o rachunkowości (Dz. U. z 2021 r. poz. 217), lub – osobę fizyczną zajmującą wyższe stanowisko kierownicze w przypadku udokumentowanego braku możliwości ustalenia lub wątpliwości co do tożsamości osób fizycznych określonych w tiret pierwsze–czwarte oraz w przypadku niestwierdzenia podejrzeń prania pieniędzy lub finansowania terroryzmu</li>" +
            "<li>w przypadku trustu: – założyciela, – powiernika, – nadzorcę, jeżeli został ustanowiony, – beneficjenta lub – w przypadku gdy osoby fizyczne czerpiące korzyści z danego trustu nie zostały jeszcze określone – grupę osób, w których głównym interesie powstał lub działa trust, – inną osobę sprawującą kontrolę nad trustem, – inną osobę fizyczną posiadającą uprawnienia lub wykonującą obowiązki równoważne z określonymi w tiret pierwsze–piąte</li>" +
            "<li> w przypadku osoby fizycznej prowadzącej działalność gospodarczą, wobec której nie stwierdzono przesłanek lub okoliczności mogących wskazywać na fakt sprawowania kontroli nad nią przez inną osobę fizyczną lub osoby fizyczne, przyjmuje się, że taka osoba fizyczna jest jednocześnie beneficjentem rzeczywistym</li>" +
            "</ol>",
          allowHTML: true,
          maxWidth: "100em",
        });
    },
    addBeneficiaryMember() {
      this.beneficiaries.push({});
    },
    removeBeneficiaryMember(key) {
      this.beneficiaries.splice(key, 1);
    },
    checkOc: function (object) {
      object.value === "inne"
        ? (this.selectedOc = true)
        : (this.selectedOc = false);
    },
    checkInsurances: function (event) {
      if (
        this.selectedInsurances.indexOf(event.target.value) === -1 &&
        event.target.checked
      ) {
        this.selectedInsurances.push(event.target.value);
      } else if (this.selectedInsurances.indexOf(event.target.value) !== -1) {
        this.selectedInsurances.splice(
          this.selectedInsurances.indexOf(event.target.value),
          1
        );
      }
      this.hiddenPropertyOptions =
        this.selectedInsurances.indexOf("OC prywatne") !== -1 &&
        this.selectedInsurances.length < 2
          ? true
          : false;
    },
    checkCountry: function (event) {
      let diseasesString = "Rozszerzenie ochrony o choroby przewlekłe";
      let diseasesIndex =
        this.items.turystykaItems.range.indexOf(diseasesString);
      let healingCostsString = "Koszty leczenia";
      let healingCostsIndex =
        this.items.turystykaItems.range.indexOf(healingCostsString);
      if (event.target.value === "Polska" && event.target.checked) {
        this.items.turystykaItems.range.splice(diseasesIndex, 1);
        this.items.turystykaItems.range.splice(
          healingCostsIndex,
          1,
          "Koszty leczenia dla cudzoziemców"
        );
      } else if (event.target.value !== "Polska") {
        if (diseasesIndex === -1) {
          this.items.turystykaItems.range.splice(2, 0, diseasesString);
        }
        if (healingCostsIndex === -1) {
          this.items.turystykaItems.range.splice(0, 1, healingCostsString);
        }
      }
    },
    scrollToAnchor(aid) {
      let aTag = $("#" + aid);
      if (typeof aTag !== "undefined" && typeof aTag.offset() !== "undefined") {
        $("html,body").animate({ scrollTop: aTag.offset().top - 160 }, "slow");
      }
    },
  },
  watch: {
    agree() {
      let self = this;
      if (this.agree !== 1) {
        self.codeSend = false;
        this.$nextTick(function () {
          tippy("[data-tippy-content]");
          self.tippy();
          ajax.postValidate(
            $("#client-apk-form"),
            this,
            function (form, vm, data) {
              console.log(data);
              self.sending = false;
              self.$emit("forward");
            },
            function (data) {
              $(".form-error").html(data.message);
              $(".form-error").show();
              self.error = data.message;
              self.sending = false;
            },
            function () {
              $(".form-error").hide();
              self.error = null;
              self.sending = true;
            }
          );
          tippy(".property-range1", {
            content:
              "Katalog ściśle określonych zdarzeń losowych przez Towarzystwo Ubezpieczeniowe.",
          });
          tippy(".life-item1 .ang-form-label", {
            content:
              "Zadbaj o swoje zdrowie w przypadku m.in. uszczerbku na zdrowiu, pobytu w szpitalu, poważnego zachorowania, operacji itd.",
          });
        });
      }
    },
  },
};
</script>
